<template>
    <div class="content_box">
        <div class="content">
            <div class="contain-box">
                <div class="info_box">
                    <div class="info">
                        <div class="title-box">
                            <span class="title_span"></span>&nbsp;&nbsp;
                            <p>用户信息</p>
                        </div>
                        <el-descriptions :column="1">
                            <el-descriptions-item label="用户ID">
                                <div>
                                    <span>{{ fbInfo.user_id }}</span>&nbsp;&nbsp;
                                    <el-button class="kd" type="text" @click="goUserDetail(fbInfo.user_id)"
                                        v-if="fbInfo.user_id && roleCheck('104-101-101-101')">
                                        查看
                                    </el-button>
                                </div>
                            </el-descriptions-item>
                            <!-- <el-descriptions-item label="昵称">{{ fbInfo.user_name }}</el-descriptions-item> -->
                            <el-descriptions-item label="手机型号">{{ fbInfo.phone_model }}</el-descriptions-item>
                            <el-descriptions-item label="APP版本号">{{ fbInfo.app_version }}</el-descriptions-item>
                            <el-descriptions-item label="手机系统版本">{{ fbInfo.dev_sys_ver }}</el-descriptions-item>
                            <el-descriptions-item label="国家/地区">{{ fbInfo.area }}</el-descriptions-item>
                        </el-descriptions>
                        <div class="title-box">
                            <span class="title_span"></span>&nbsp;&nbsp;
                            <p>问题信息</p>
                        </div>
                        <el-descriptions :column="1">
                            <el-descriptions-item label="问题ID">{{ fbInfo.id }}</el-descriptions-item>
                            <el-descriptions-item label="创建时间">{{ formDate(fbInfo.create_time) }}</el-descriptions-item>
                            <el-descriptions-item label="问题类型">{{ fbInfo.question_type == 1 ? '问题反馈' : '产品建议'
                            }}</el-descriptions-item>
                            <el-descriptions-item label="产品型号">{{ fbInfo.product }}</el-descriptions-item>
                            <el-descriptions-item label="设备名">{{ fbInfo.device_nick_name }}</el-descriptions-item>
                            <el-descriptions-item label="SN">{{ fbInfo.SN }}&nbsp;&nbsp;
                                <el-button type="text" @click="goDeviceDetail(fbInfo.SN)"
                                    v-if="fbInfo.SN && roleCheck('104-102-101-101')">查看</el-button>
                            </el-descriptions-item>
                            <el-descriptions-item label="是否解决">
                                <el-radio-group v-model="fbInfo.is_solved" size="small">
                                    <el-radio-button :label="1">是</el-radio-button>
                                    <el-radio-button :label="2">否</el-radio-button>
                                    <el-radio-button :label="0">未填写</el-radio-button>
                                </el-radio-group>
                            </el-descriptions-item>
                            <el-descriptions-item label="备注">
                                <el-input v-model="fbInfo.remarks" type="textarea" :row="2" placeholder="输入备注内容">{{
                                        fbInfo.remarks
                                }}</el-input>
                            </el-descriptions-item>
                        </el-descriptions>

                    </div>
                    <div class="btn">
                        <div class="button" @click="updateFbInfo" v-if="roleCheck('103-101-101-102')">
                            <span>修改</span>
                        </div>&nbsp;&nbsp;
                        <div class="button white" @click="toCreateOrder"
                            v-if="this.fbInfo.work_id == 0 && roleCheck('103-101-101-103') && roleCheck('101-102-101-102')">
                            <span>转工单</span>
                        </div>
                        <div class="button white" @click="toOrderDetail(fbInfo.work_id,fbInfo.title)"
                            v-if="this.fbInfo.work_id != 0 && roleCheck('101-102-101-101')">
                            <span>查看工单</span>
                        </div>
                    </div>
                </div>
                <div class="talk_box">
                    <div class="talks">
                        <el-scrollbar style="height: 100%" ref="leftScrollbar">
                            <div style="padding: 20px;" ref="talks_h">
                                <div v-for="(item, index) in talkList" v-if="talkList.length > 0">
                                    <el-row :key="index">
                                        <div class="talk_item" :class="item.type == 0 ? 'talk-left' : 'talk-right'">
                                            <p class="talk_title">{{ formDate(item.create_time) }}&nbsp;&nbsp;{{
                                                    item.type == 0 ?
                                                        fbInfo.user_name : 'Neakasa'
                                            }}</p>
                                            <p class="talk_text">{{ item.text }}</p>
                                            <fileShow :fileList="item.files.split(',')" :type="'log'" download="false"
                                                v-if="item.files">
                                            </fileShow>
                                        </div>
                                    </el-row>
                                </div>
                            </div>
                        </el-scrollbar>
                    </div>
                    <div class="reply">
                        <el-form>
                            <el-form-item label="回复">
                                <el-input type="textarea" :rows="4" v-model="formData.text" class="text-box">{{
                                        formData.text
                                }}</el-input>
                            </el-form-item>
                            <!-- <el-form-item style="margin-bottom: 0;">
                            <el-upload class="upload-demo" :action="uploadUrl" multiple :limit="4">
                                <el-button size="small" type="primary">上传文件</el-button>
                            </el-upload>
                        </el-form-item> -->
                            <div class="reply-box">
                                <el-form-item class="block">
                                    <upload ref="feedback" path="order/create/" :limit="4" @fileChange="fileChange"
                                        v-if="roleCheck('103-101-101-102')"></upload>
                                </el-form-item>
                                <el-form-item style="text-align: end;">
                                    <el-row>
                                        <div class="button" @click="sendTalk" v-if="roleCheck('103-101-101-102')">
                                            <span>发送</span>
                                        </div>
                                    </el-row>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>
<script>
import fileShow from '../../../components/file/file-show'
import upload from '../../../components/file/upload'
export default ({
    name: 'feedback-detail',
    data() {
        return {
            feedback_id: '',
            fbInfo: [],
            talkList: [],
            formData: {
                text: '',
                files: '',
            },
            fileList: [],
            filePath: [],
            countryList: [],
            userInfo: {},
            // countryName:''
        }
    },
    components: {
        fileShow,
        upload
    },
    created() {
        this.getCountry();
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    },
    activated() {
        this.feedback_id = parseInt(this.$route.params.id);
        this.getFbInfo();
        this.getTalkList();
    },
    methods: {
        getFbInfo() {
            this.api.getFbList({ id: this.feedback_id, current_name: this.userInfo.name }).then(data => {
                if (data.data.total == 0) {
                    this.$message.warning('反馈信息不存在！');
                    this.$router.push({ name: 'user-feedback', query: {region: this.$route.query.region}})
                    return;
                }
                var list = data.data.feedback_list[0];
                this.countryList.forEach(country => {
                    if (country.abbr == list.area || country.code == list.area) {
                        list.area = country.chinese + '(+' + country.code + ')';
                        return;
                    }
                })
                this.fbInfo = list;
            })
        },
        updateFbInfo() {
            var updateData = {
                feedback_id: this.feedback_id,
                is_solved: this.fbInfo.is_solved,
                is_read: 1,
                remarks: this.fbInfo.remarks
            }
            this.api.updateFb(updateData).then(data => {
                this.$message.success('修改成功！');
                // if (updateData.is_solved || updateData.remarks) {
                // }
            })
        },
        getTalkList() {
            this.api.getFbContentList({
                feedback_id: this.feedback_id,
                page: 1,
                page_size: 100
            }).then(data => {
                // console.log(data.data.fbcount_list)               
                this.talkList = data.data.fbcount_list
                this.$nextTick(() => {
                    this.$refs.leftScrollbar.wrap.scrollTop = this.$refs.talks_h.offsetHeight;
                    // console.log(this.$refs.talks_h.offsetHeight)
                })
            })
        },
        sendTalk() {
            if (this.filePath.length == 0 && this.formData.text == '') {
                this.$message.warning('请上传文件或输入文本！');
            } else {
                var talkData = {
                    user_id: this.fbInfo.user_id,
                    user_name: this.fbInfo.user_name, // 账号名称
                    feedback_id: this.feedback_id, // 问题id
                    files: this.filePath.toString(), // 文件url
                    text: this.formData.text, // 内容
                }
                this.api.addFbContent(talkData).then(data => {
                    this.$message.success('发送成功！');
                    this.getTalkList();
                    this.cleanData();
                })
            }
        },
        fileChange(file, type, i) {
            if (type == 'upload') {
                this.filePath.push(file);
            } else {
                this.filePath.splice(i, 1);
            }
        },
        toCreateOrder() {
            this.$router.push({ name: 'create-order', query: { feedback_id: this.feedback_id, region: this.$route.query.region } });
        },
        cleanData() {
            this.fileList = [];
            this.filePath = [];
            this.$refs.feedback.fileList = [];
            this.$refs.feedback.fileSize = 0;
            this.$refs.feedback.$refs.upload.clearFiles();
            this.formData = {
                text: '',
                files: '',
            }
        },
        getCountry() {
            this.api.getCountry({}).then(data => {
                this.countryList = data.data.country;
            })
        },
        goUserDetail(id) {
            if (window.h5sdk) {
                this.$router.push({ name: 'user-detail', params: { id: id }, query: { region: this.$route.query.region } });
                return;
            }
            const page = this.$router.resolve({
                name: 'user-detail',
                params: { id: id }, query: { region: this.$route.query.region }
            });
            window.open(page.href, "_blank");
        },
        goDeviceDetail(sn) {
            this.api.getIotDeviceDetail({ deviceName: sn }).then(data => {
                if (data.data.result) {
                    var res = data.data.result[0];
                    if (window.h5sdk) {
                        this.$router.push({ name: 'device-detail', params: { id: res.iotId }, query: { region: res.region, deviceName: res.deviceName } });
                        return;
                    }
                    const page = this.$router.resolve({
                        name: 'device-detail',
                        params: { id: res.iotId }, query: { region: res.region, deviceName: res.deviceName }
                    });
                    window.open(page.href, "_blank");
                } else if (data.code == 50001) {
                    this.$message.error(data.msg);
                }
            })
        }, toOrderDetail(work_id, title) {
            if (window.h5sdk) {
                this.$router.push({ name: 'order-detail', params: { id: work_id }, query: { title: title } });
                return;
            }
            const detail = this.$router.resolve({
                name: `order-detail`,
                params: {
                    id: work_id
                },
                query: {
                    title: title
                }
            });
            window.open(detail.href, "_blank");
        },
    }
})
</script>
<style lang="less" scoped>
.title-box {
    display: flex;
    padding: 20px 20px 10px 20px;
    font-size: 18px;
    font-weight: bold;
    align-items: center;

    .title_span {
        width: 6px;
        height: 20px;
        background: #5192FF;
    }
}

.content {
    padding: 0;
}

.contain-box {
    background: white;
    height: 100%;
    min-height: 700px;
    .flexLayout(flex-start, flex-start);

    .info_box {
        border-right: 1px solid #ccc;
        width: 30%;
        min-height: 100%;
        .flexLayout(flex-start, flex-start);
        flex-direction: column;
        flex-wrap: nowrap;

        .info {
            width: 100%;

            /deep/ .el-descriptions-item__cell {
                padding: 10px 20px;
            }

            /deep/ .el-descriptions-item__label:not(.is-bordered-label) {
                width: 100px;
                color: #999999;
            }

            /deep/ .el-descriptions-item__container {
                align-items: center;
            }
        }

        .btn {
            display: flex;
            flex: 1;
            margin: 0 auto;
            align-items: center;
            padding: 20px;

            /deep/ .el-button {
                height: 40px;
            }
        }

    }

    .talk_box {
        width: 67%;
        // padding: 0% 1%;
        height: 100%;

        .talks {
            height: 55%;
            border: 1px solid #ccc;
            border-radius: 4px;
            margin: 3% 0 3% 3%;

            .talk_title {
                color: #898C9C;
            }

            .talk_text {

                font-size: 14px;
                letter-spacing: 1px;
            }
        }

        .text-box {
            border: 1px solid #409eff;
            border-radius: 4px;
        }

        .talk_item {
            padding-bottom: 10px;
            width: 70%;

            &.talk-right {
                float: right;
                text-align: right;
            }
        }

        .talk-left {
            margin-right: 50%;
        }

        .talk-right /deep/ .files_box {
            justify-content: flex-end;
        }

        .reply {
            margin-left: 3%;

            .reply-box {
                display: flex;
                justify-content: space-between;
            }
        }



        .button {
            margin-right: 0;
        }

        /deep/ .el-scrollbar__wrap {
            overflow-x: hidden !important;
        }

        /deep/ .el-scrollbar__bar.is-horizontal {
            display: none;
        }
    }


}
</style>


// WEBPACK FOOTER //
// src/view/app/user-feedback/feedback-detail.vue